
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/compliance/iec-62443",
      function () {
        return require("private-next-pages/compliance/iec-62443.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/compliance/iec-62443"])
      });
    }
  